import React, { useEffect, useState } from 'react';
import Routes from './routes';
import PropTypes from 'prop-types';
import { retrieveAnonId, storeAnonId } from './lib/cookies';
import getStateFromUrl from './lib/getStateFromUrl';
import sbjs from 'sourcebuster';
import initializeDatadogRUM from "./vendor/initializeDatadogRUM";

const App = ({ processAndStoreUrlData }) => {
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    sbjs.init({ timezone_offset: 0 });
    if (!retrieveAnonId()) {
      storeAnonId();
    }

    const urlStateData = getStateFromUrl();
    processAndStoreUrlData(urlStateData);
    setLoading(false);
  }, [processAndStoreUrlData]);

  useEffect(() => {
    initializeDatadogRUM();
  }, []);

  return !isLoading && <Routes />;
};

App.propTypes = {
  processAndStoreUrlData: PropTypes.func.isRequired,
};

export default App;
